// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"279e8d06","239":"e630c766","455":"2dd12853"}[chunkId] + ".chunk.js";
};